import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import ModalBody from '../ModalBody';
import s from './ModalFormBody.scss';
const ModalFormBody = (_param)=>{
    var { children, onSubmit } = _param, rest = _object_without_properties(_param, [
        "children",
        "onSubmit"
    ]);
    return /*#__PURE__*/ React.createElement(ModalBody, rest, /*#__PURE__*/ React.createElement("form", {
        className: s['form'],
        /**
         * Forms add their fields to the url's search string by default. We usually handle this type of submission via
         * redux without a page load, so we don't need those params in the search string. This empty `action` attribute
         * prevents that.
         */ action: "",
        onSubmit: onSubmit
    }, children));
};
ModalFormBody.displayName = 'ModalFormBody';
export default ModalFormBody;

//# sourceMappingURL=ModalFormBody.js.map